import React from 'react';

import { Row, Col } from 'react-bootstrap';
import Button from 'src/components/button/index'; 

import TinyMCE from 'react-tinymce';
import contentStyle from './content.module.scss';

import CommonStyles from '../../Styles.module.scss';
import styles from './style.module.scss';
import { localizedStrings } from 'src/localization/index.jsx';

class EmailSignatureView extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      emailSignature: this.props.emailSignature || ''
    }

    this._handleChange = this._handleChange.bind(this);
    this._handleUpdateClick = this._handleUpdateClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizatedSettings = localizedStrings.pages.settings;
    this.localizedProfile = this.localizatedSettings.profile;
    this.localizedEmailSignature = this.localizedProfile.email_signature;
  }

  _handleChange(e) {
    this.setState({
      emailSignature: e.target.getContent()
    })
  }

  _handleUpdateClick() {
    let request = {
      emailSignature: this.state.emailSignature,
    }

    this.props.updateEmailSignature(request)
  }

  _handleCancelClick(){
    this.setState({
      emailSignature: this.props.emailSignature
    }, () => {
      if(this.composeEditor){
        this.composeEditor.setContent(this.state.emailSignature);  
      }
    });
  }

  render() {
    return (
      <div>
        <Row className={CommonStyles.row}>
          <Col className={styles.signature}>
            <h1 className={styles.title}>{this.localizedEmailSignature.title}</h1>
            <p className={styles.description}>{this.localizedEmailSignature.description}</p>
            <TinyMCE
              content={this.state.emailSignature}
              config={{
                branding: false,
                statusbar: false,
                plugins: 'noneditable, variable, widget,  autolink, link, image, code, textcolor, lists, paste',
                menubar: false,
                toolbar: 'bold italic | alignleft aligncenter alignright | numlist bullist | fontselect | fontsizeselect | forecolor backcolor | image link | code',
                resize: false,
                height: 200,
                content_css: [
                  'https://maxcdn.bootstrapcdn.com/bootstrap/latest/css/bootstrap.min.css',
                  contentStyle
                ],
                font_formats: 'Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbat',              
                default_link_target: "_blank",
                fontsize_formats: '5pt 5.5pt 6.5pt 7.5pt 8pt 9pt 10pt 10.5pt 11pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 26pt 28pt 36pt 48pt 72pt',
                paste_retain_style_properties: "color",
                resize: false,
                browser_spellcheck : true,
                setup: (editor)=>{
                  this.composeEditor = editor;
                },
                convert_urls: false,
                relative_urls: false,
                remove_script_host: false,    
              }}
              onChange={this._handleChange}

            />
          </Col>
        </Row>
        <div className={ styles.buttonTray }>
            <Button
              variant='primary'
              text={this.props.updating ? `${this.localizedCommonActions.saving}...` : this.localizedCommonActions.save}
              disabled={this.props.updating}
              className={styles.confirm}
              onClick={this._handleUpdateClick}
              icon='paperflite-tick'
            >
            </Button>
            <Button
              variant='secondary'
              text={this.localizedCommonActions.cancel}
              disabled={this.props.updating}
              className={styles.cancel} 
              onClick={this._handleCancelClick}>
            </Button> 
        </div>
      </div>
    )      
  }
}

export default EmailSignatureView;